import React from 'react';
import { backgroundModal, boxModal } from './ModalAccessCss';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { Box } from '@mui/system';
import ClearIcon from '@mui/icons-material/Clear';
import { Grid, Button, IconButton } from '@mui/material';
import thLocale from 'dayjs/locale/th';
import dayjs from 'dayjs';
import { notifyInfo } from '../NotifyToast';

function ModalCalendar({
    onFinished,
    onClose,
    value,
    onChange,
    disableDay
}) {

    const shouldDisableDate = (date) => {
        //const tomorrow = dayjs().add(1, 'day').startOf('day');
        const today = dayjs().startOf('day');
        const current = dayjs(date).startOf('day');
        const dayOfWeek = date.$d.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

        return current.isBefore(today) || (disableDay?.includes(dayOfWeek) ?? false);
    };

    return (
        <Box sx={backgroundModal}>
            <Box sx={boxModal}>
                <Box sx={{ textAlign: 'end', '&:hover': { cursor: 'pointer' } }}>
                    <IconButton onClick={onClose}>
                        <ClearIcon />
                    </IconButton>
                </Box>

                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
                    <DateCalendar
                        value={value}
                        onChange={onChange}
                        shouldDisableDate={shouldDisableDate}
                    />
                </LocalizationProvider>

                <Grid container justifyContent="center" gap={2} sx={{ mt: 2 }}>
                    <Grid item>
                        <Button variant="outlined" onClick={onClose}>
                            ยกเลิก
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" onClick={() => {
                            if (!value) {
                                notifyInfo('กรุณาเลือกวันที่ก่อนยืนยัน');
                            } else {
                                onFinished(value); // เปลี่ยนจาก 'eiei' เป็นค่าจริง
                                onClose();
                            }
                        }}>
                            ยืนยัน
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default ModalCalendar;
